<template>
  <div class="identity-form">
    <div class="double">
      <FormKit
          label="Vorname"
          type="text"
          validation="required"

          :validation-messages="{
          required: 'Vorname ist erforderlich'
    }"
          v-model="identity.firstName"
          @input="emitIdentity('firstName', $event)"
      />
      <FormKit
          label="Nachname"
          type="text"
          validation="required"

          :validation-messages="{
          email: 'Dies ist keine gültige email',
          required: 'Nachname ist erforderlich'
    }"
          v-model="identity.lastName"
          @input="emitIdentity('lastName', $event)"
      />
    </div>

    <FormKit
        label="E-Mail"
        validation="required|email"

        :validation-messages="{
          email: 'Dies ist keine gültige email',
          required: 'Email ist erforderlich'

    }"
        type="email"
        v-model="identity.email"
        @input="emitIdentity('email', $event)"
    />

    <FormKit
        label="Zusätzliche Informationen"
        rows="6"
        type="textarea"
        outer-class="textarea"
        style="resize: none;"
        placeholder="Geben Sie uns weitere Details, die Sie für wichtig halten."
        v-model="identity.additionalInfo"
        @input="emitIdentity('additionalInfo', $event)"
    />
  </div>
</template>

<script>
export default {
  name: "IdentityForm",
  data() {
    return {
      identity: {
        firstName: "",
        lastName: "",
        email: "",
        additionalInfo: ""
      }
    };
  },
  methods: {
    emitIdentity(field, value) {
      this.identity[field] = value || "";
      this.$emit("updateIdentity", { ...this.identity });
    }
  }
};
</script>

<style scoped>
.double {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.double > * {
  width: 100%;
}

.identity-form {
  padding-left: 1px;
  padding-right: 1px;
  height: 100%;
}

@media (max-width: 600px) {
  .double {
    flex-direction: column;
    gap: 0;
  }
}
</style>
